<template>
  <section>
    <!-- Main navbar -->
    <top-menu
      @showMenu="showLeftMenu()"
      @hideMenu="hideLeftMenu()"
    />

    <!-- Page content -->
    <div class="page-content">
      <!-- Main sidebar -->
      <left-menu />
      <div class="content-wrapper">
        <!-- <header-content></header-content> -->
        <div class="content p-0">
          <slot />
        </div>
        <footer-content />
      </div>
    </div>
    <!-- /page content -->
  </section>
</template>

<script>
import TopMenu from "./template/TopMenu";
import LeftMenu from "./template/LeftMenu";
//  import HeaderContent from './template/HeaderContent'
import FooterContent from "./template/FooterContent";

export default {
  components: {
    TopMenu,
    LeftMenu,
    //  HeaderContent,
    FooterContent,
  },
  data() {
    return {
      hoverLogo: false,
    };
  },
  methods: {
    showLeftMenu() {
      this.hoverLogo = true
    },
    hideLeftMenu() {
      this.hoverLogo = false
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/layouts/web/SocialLayoutNoHeader.vue